module.exports = __webpack_public_path__ + "_/_/src/assets/firesafety/fire-exit-left/legend.png";